<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" offset-md="3">
        <form @submit.prevent="save">
          <DateSelector
            :date="form.date"
            @change="updateDate"
          />
          <FormErrors
            v-if="$v.form.$error && (!$v.form.date.required)"
          >
            <FormErrorsLine v-if="!$v.form.date.required" text="Polje je obvezno" />
          </FormErrors>

          <v-text-field
            v-model="form.delivery_document"
            label="Št. prevzemnice *"
          ></v-text-field>
          <FormErrors
            v-if="$v.form.$error && (!$v.form.delivery_document.required)"
          >
            <FormErrorsLine v-if="!$v.form.delivery_document.required" text="Polje je obvezno" />
          </FormErrors>
          <v-select
            :items="localClients"
            item-text="name"
            item-value="id"
            v-model="form.client"
            label="Dobavitelj *"
          >
            <v-tooltip
              top
              slot="append-outer"
            >
              <template v-slot:activator="{ on }">
                <v-btn icon small @click="showAddClientModal = true" v-on="on">
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-btn>
              </template>
              <span>Dodaj novega dobavitelja</span>
            </v-tooltip>
          </v-select>
          <FormErrors
            v-if="$v.form.$error && (!$v.form.client.required)"
          >
            <FormErrorsLine v-if="!$v.form.client.required" text="Polje je obvezno" />
          </FormErrors>
          <v-textarea
            v-model="form.comment"
            label="Komentar"
          >
          </v-textarea>
          <v-btn v-if="!skrij" type="submit" class="float-right">Nadaljuj</v-btn>
          <!-- <v-btn v-if="!modalView && isNewAcceptanceForm" type="button" class="float-right mr-4" @click="saveAndRepeat">Shrani in dodaj novo</v-btn> -->
          <v-btn v-if="!skrij" text type="button" class="float-right mr-4" @click="cancel">Prekliči</v-btn>
          <div style="display: none;">
            {{spremenjenDatum}}
            {{spremenjenoStPrevzemnice}}
            {{spremenjenoDobavitelj}}
            {{spremenjenoKomentar}}
          </div>
        </form>
      </v-col>
    </v-row>

    <PopupAddCompanyClient
      ref="addClientFormModal"
      :countryList="countryList"
      v-model="showAddClientModal"
      @confirmed="addClient"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import PopupAddCompanyClient from '@/components/PopupAddCompanyClient'
import DateSelector from './DateSelector.vue'

export default {
  components: {
    FormErrors,
    FormErrorsLine,
    DateSelector,
    PopupAddCompanyClient
  },
  props: {
    clients: {
      required: true,
      type: Array
    },
    acceptanceForm: {
      default: () => {},
      type: Object
    },
    countryList: {
      required: true,
      type: Array
    },
    skrij: {
      required: false,
      type: Boolean,
      default: false
    },
    type: {
      required: false,
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      localStaraForm: null,
      localClients: [],
      showAddClientModal: false,
      emptyForm: {
        date: moment().format('YYYY-MM-DD'),
        delivery_document: null,
        client: null,
        comment: null
      },
      form: {},
      dataFetched: false,
      razlog: null
    }
  },
  validations: {
    form: {
      date: {
        required
      },
      delivery_document: {
        required
      },
      client: {
        required
      }
    }
  },
  computed: {
    isNewAcceptanceForm () {
      return !this.acceptanceForm || Object.values(this.acceptanceForm).length === 0
    },
    spremenjenDatum () {
      return this.localStaraForm ? this.form.date !== this.localStaraForm.date : false
    },
    spremenjenoStPrevzemnice () {
      return this.localStaraForm ? this.form.delivery_document !== this.localStaraForm.delivery_document : false
    },
    spremenjenoDobavitelj () {
      return this.localStaraForm ? this.form.client !== this.localStaraForm.client : false
    },
    spremenjenoKomentar () {
      return this.localStaraForm ? this.form.comment !== this.localStaraForm.comment : false
    }
  },
  methods: {
    ...mapActions('clients', { saveCompanyClient: 'saveItem' }),
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    saveAndRepeat () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form, repeat: true })
      }
    },
    clearForm () {
      this.form = { ...this.emptyForm }
      this.$v.$reset()
    },
    cancel () {
      this.$emit('cancel')
    },
    updateDate ({ date }) {
      this.form.date = date
    },
    addClient ({ data }) {
      this.saveCompanyClient(data)
        .then(newClient => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          this.showAddClientModal = false
          this.$refs.addClientFormModal.clearForm()
          this.localClients.push(newClient)
          this.form.client = newClient.id
        })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.dataFetched = true
    })
  },
  created () {
    this.form = { ...this.emptyForm }
    this.form.type = this.type
    this.localClients = this.clients
    if (!this.isNewAcceptanceForm) {
      this.form = { ...this.form, ...this.acceptanceForm }
    }
    this.localStaraForm = { ...this.form }
    this.localStaraForm.comment = this.localStaraForm.comment === null ? '' : this.localStaraForm.comment
  },
  watch: {
    spremenjenDatum (sprememba) {
      const razlog = 'spremenjenDatum'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoStPrevzemnice (sprememba) {
      const razlog = 'spremenjenStPrevzemnice'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoDobavitelj (sprememba) {
      const razlog = 'spremenjenDobavitelj'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoKomentar (sprememba) {
      const razlog = 'spremenjenKomentar'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    }
  }
}
</script>
